import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DailySupport from "../pages/daily-support/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/daily-support",
    element: <DailySupport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
